import styled from "@emotion/styled";
import { Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import PbFloatingMenuProps from "./PbFloatingMenuProps.type";
import { Scrollbars } from "react-custom-scrollbars-2";

const MenuContainer = styled.div((props: { expanded: boolean }) => ({
  position: "fixed",
  top: "25px",
  bottom: "25px",
  left: "25px",
  width: props.expanded ? "20%" : "4%",
  boxShadow: "0px 3px 6px #00000029",
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  zIndex: 1000,
  background: "#FFFFFF",
}));

const LogoContainer = styled.div({
  height: "10%",
});

const ContentConainer = styled(Paper)({
  width: "90%",
  height: "80%",
  maxHeight: "80%",
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  overflowX: "hidden",
});

const ActionsConainer = styled.div((props: { expanded: boolean }) => ({
  display: "flex",
  flexDirection: props.expanded ? "row" : "column",
  alignItems: props.expanded ? "flex-end" : "center",
  justifyContent: "flex-end",
  height: "10%",
  width: props.expanded ? "100%" : "60%",
}));

const IconContainer = styled.div((props: { expanded: boolean }) => ({
  margin: "7px",
}));

const PbFloatingMenu = (props: PbFloatingMenuProps) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <MenuContainer expanded={expanded}>
      <LogoContainer onClick={props.logoOnClick}>
        {expanded ? props.expandedLogo : props.logo}
      </LogoContainer>
      <ContentConainer className="hide-scroll-content">
        <Scrollbars autoHide autoHideTimeout={0}>
          {props.getContent(expanded)}
        </Scrollbars>
      </ContentConainer>
      <ActionsConainer expanded={expanded}>
        <IconContainer expanded>
          {props.store ? props.storeComponent : null}
        </IconContainer>
        <IconContainer
          expanded
          onClick={() => {
            setExpanded(!expanded);
          }}
        >
          {props.expandable ? props.expandIcon : null}
        </IconContainer>
      </ActionsConainer>
    </MenuContainer>
  );
};

export default PbFloatingMenu;
